import styled from 'styled-components/macro';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const StyledFlexContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  grid-gap: 32px;
`;
